import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { course_enrollment_completed, course_enrollment_inProgress } from '@paraglide/messages';
import styled from '@emotion/styled';
import { CheckCircle } from 'lucide-react';
import { Award } from 'lucide-react';
const ProgressContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
const StatusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.75rem;
  background-color: ${(props)=>props.variant === 'completed' ? '#10b981' : '#3b82f6'};
  color: white;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;
  min-width: fit-content;
`;
const ProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
const ProgressBarContainer = styled.div`
  width: 100px;
  height: 8px;
  background-color: #e5e7eb;
  border-radius: 9999px;
  overflow: hidden;
`;
const ProgressBarFill = styled.div`
  width: ${(props)=>props.progress}%;
  height: 100%;
  background-color: #3b82f6;
  transition: width 0.3s ease;
`;
const ProgressText = styled.span`
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
`;
export const CourseHeaderProgress = ({ isEnrolled, isCompleted, progressRate })=>{
    const progressPercent = progressRate ? parseInt(progressRate) : 0;
    if (isCompleted) {
        return /*#__PURE__*/ _jsx(ProgressContainer, {
            children: /*#__PURE__*/ _jsxs(StatusBadge, {
                variant: "completed",
                children: [
                    /*#__PURE__*/ _jsx(Award, {
                        size: 12
                    }),
                    course_enrollment_completed()
                ]
            })
        });
    }
    if (isEnrolled) {
        return /*#__PURE__*/ _jsxs(ProgressContainer, {
            children: [
                /*#__PURE__*/ _jsxs(StatusBadge, {
                    variant: "enrolled",
                    children: [
                        /*#__PURE__*/ _jsx(CheckCircle, {
                            size: 12
                        }),
                        course_enrollment_inProgress()
                    ]
                }),
                /*#__PURE__*/ _jsxs(ProgressWrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(ProgressBarContainer, {
                            children: /*#__PURE__*/ _jsx(ProgressBarFill, {
                                progress: progressPercent
                            })
                        }),
                        /*#__PURE__*/ _jsxs(ProgressText, {
                            children: [
                                progressPercent,
                                "%"
                            ]
                        })
                    ]
                })
            ]
        });
    }
    return null;
};
